import { TaskScheduler } from "src/models/workflowLayout";
import { createEntityModel } from "src/store/models/entity/_shared";

export const WorkflowLayoutTriggerEntityModel =
  createEntityModel<TaskScheduler>();
